/*
 * @Author: zhaoyang
 * @Date: 2022-11-28 17:52:03
 * @Last Modified by: zhaoyang
 * @Last Modified time: 2024-12-19 18:21:31
 */

import {upperFirst} from 'lodash';
import {mapState, mapActions} from 'vuex';

import EventUtil from 'easycash/common/util/event';
import {
    genClickEvent,
    genSensorsEvent,
    genEnterEvent,
    genClickEventNoPrefix
} from 'easycash/common/util/event-helper';
import {getKey} from 'easycash/common/util/gen-key';

export default {
    provide() {
        const {uploadClickEvent, uploadSensorsEvent} = this;

        return {uploadClickEvent, uploadSensorsEvent};
    },

    data() {
        const withUserKey = this.$route.meta?.business?.withUserKey;
        const userKey = withUserKey ? getKey() : '';

        return {
            userKey
        };
    },

    computed: {
        ...mapState('baseData', ['brand']),

        ...mapState('userStatus', ['status']),

        withUserKey() {
            return this.$route.meta?.business?.withUserKey;
        },

        withUserStatus() {
            return this.$route.meta?.business?.withUserStatus;
        }
    },

    methods: {
        ...mapActions('userStatus', ['getUserStatus']),

        getElementContent(elementContent = {}, uploadQuery = false) {
            const {
                withUserKey,
                userKey,
                withUserStatus,
                status = {},
                $route: {query}
            } = this;

            let content = withUserKey ? {...elementContent, userKey} : elementContent;

            if (withUserStatus) {
                content = {...content, ...status};
            }

            if (uploadQuery) {
                content = {...content, ...query};
            }

            return content;
        },

        async uploadClickEvent(tag, elementContent, useAppMethod) {
            const {getElementContent} = this;

            await EventUtil.uploadEvent(
                genClickEvent(upperFirst(this.brand), tag, getElementContent(elementContent)),
                this.$route,
                this.brand,
                useAppMethod
            );
        },

        async uploadClickEventNoPrefix(tag, elementContent, useAppMethod) {
            const {getElementContent} = this;

            await EventUtil.uploadEvent(
                genClickEventNoPrefix(tag, getElementContent(elementContent)),
                this.$route,
                this.brand,
                useAppMethod,
                true
            );
        },

        // 上报神策，埋点名称以神策为准，不拼接，产品保证埋点名称唯一
        async uploadSensorsEvent(tag, elementContent, useAppMethod) {
            const {getElementContent} = this;

            await EventUtil.uploadSensorsEvent(
                genSensorsEvent(tag, getElementContent(elementContent)),
                this.$route,
                this.brand,
                useAppMethod
            );
        },

        async uploadEnterEvent(elementContent, uploadQuery) {
            const {withUserStatus} = this;

            if (withUserStatus) {
                await this.getUserStatus();
            }

            const {getElementContent, $route, brand} = this;
            await EventUtil.uploadEvent(
                genEnterEvent(upperFirst(brand), $route, getElementContent(elementContent, uploadQuery)),
                $route,
                brand
            );
        },

        uploadEvent(evt) {
            const {brand, $route, getElementContent} = this;
            if (!brand) return;
            let {target} = evt;
            let tag = target.dataset.upload;
            let value = target.dataset.params;

            while (!tag && target) {
                target = target?.parentNode;
                tag = target?.dataset?.upload;
                value = target?.dataset?.params;
            }

            if (!tag) return;

            if (value) {
                try {
                    value = JSON.parse(value);
                } catch (error) {
                    // ignore
                }
            }

            EventUtil.uploadEvent(
                {
                    tag,
                    businessEvent: `${upperFirst(brand)}_${tag}`,
                    elementType: 'Button',
                    eventType: 'C',
                    elementContent: getElementContent(value || {})
                },
                $route,
                brand
            );
        }
    },

    mounted() {
        const {uploadEvent} = this;
        document.body.addEventListener('click', uploadEvent);
    },

    beforeDestroy() {
        const {uploadEvent} = this;
        document.body.removeEventListener('click', uploadEvent);
    }
};
